import { formatDocumentNumber } from '@sravni/cosago-react-library/lib/utils';

import { HIDE_DATA_SYMBOL } from 'constants/string';

import { removeUnderscores, replaceSpacesToUnbreakableGap } from 'shared/lib';

import type { TPassportFormFields } from 'entities/creditForm';

export const getProtectedDescriptionWithUserData = (data: Nullable<TPassportFormFields>, isHideData = false) => {
  if (!data?.passportNumber) {
    return '';
  }

  const passport = isHideData ? HIDE_DATA_SYMBOL.repeat(10) : data?.passportNumber;

  return replaceSpacesToUnbreakableGap(`Паспорт ${formatDocumentNumber(removeUnderscores(passport))}`);
};
